"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.iInternalBillingInformation = exports.iInternalProjectBilling = exports.iBillingInformation = exports._iBillingInformation = exports.iBillingAddress = exports.iProjectBilling = void 0;
const t = require("io-ts");
exports.iProjectBilling = t.interface({
    id: t.number,
    projectName: t.string
});
const _iBillingAddress = t.intersection([
    t.interface({
        id: t.number,
        customerName: t.string,
        streetAddress: t.string,
        postalCode: t.string,
        city: t.string
    }),
    t.partial({
        country: t.string,
        createdAt: t.string,
        updatedAt: t.string,
        referenceNumber: t.string,
    })
]);
exports.iBillingAddress = t.clean(_iBillingAddress);
/**
 * should be used when displaying billing related data to others
 * than Grano admin or salesman
 */
exports._iBillingInformation = t.union([
    t.intersection([
        t.interface({ type: t.literal('CUSTOM') }),
        exports.iBillingAddress
    ]),
    t.intersection([
        t.interface({
            type: t.literal('INTERNAL'),
            id: t.number,
            customerName: t.string
        }),
        t.partial({
            projects: t.array(exports.iProjectBilling),
            selectedProject: t.number
        })
    ])
]);
exports.iBillingInformation = t.clean(exports._iBillingInformation);
/**
 * should be only visible for Grano admins and salesman
 */
const _iInternalProjectBilling = t.intersection([
    t.interface({
        projectName: t.string,
        projectNumber: t.string // SonetProjectInfo/SonetProjectNumber/Nmbe
    }),
    t.partial({
        id: t.number,
        createdAt: t.string,
        updatedAt: t.string,
        deletedAt: t.string
    })
]);
exports.iInternalProjectBilling = t.clean(_iInternalProjectBilling);
const iInternal = t.intersection([
    t.interface({
        type: t.literal('INTERNAL'),
        customerNumber: t.string
    }),
    exports.iBillingAddress,
    t.partial({
        projects: t.array(exports.iInternalProjectBilling),
        selectedProject: t.number,
        locked: t.boolean
    })
]);
const iCustom = t.intersection([
    t.interface({
        type: t.literal('CUSTOM')
    }),
    exports.iBillingAddress,
    t.partial({
        locked: t.boolean
    })
]);
const _iInternalBillingInformation = t.union([
    iInternal, iCustom
]);
exports.iInternalBillingInformation = t.clean(_iInternalBillingInformation);
//# sourceMappingURL=billingInformation.js.map